export const LAYOUT_TEST_IDS = {
  // ── Header ──────────────────────────────────────────────────────────────
  HEADER: 'layout-header',
  HEADER_MOBILE_MENU_BTN: 'layout-header-mobile-menu-btn',
  HEADER_THEME_TOGGLE: 'layout-header-theme-toggle',
  HEADER_NOTIFICATION_POPOVER: 'layout-header-notification-popover',
  HEADER_USER_POPOVER: 'layout-header-user-popover',
  HEADER_LOGOUT_BTN: 'layout-header-logout-btn',
  HEADER_DATE_PICKER: 'layout-header-date-picker',

  // ── Sidebar ─────────────────────────────────────────────────────────────
  SIDEBAR: 'layout-sidebar',
  SIDEBAR_MOBILE_CLOSE_BTN: 'layout-sidebar-mobile-close-btn',
  SIDEBAR_NAV_LINK: (label: string) =>
    `layout-sidebar-nav-${label.toLowerCase().replace(/\s+/g, '-')}`,
  SIDEBAR_EXPAND_LOCK_TOGGLE: 'layout-sidebar-expand-lock-toggle',
  SIDEBAR_COLLAPSE_BTN: 'layout-sidebar-collapse-btn',

  // ── Breadcrumb ──────────────────────────────────────────────────────────
  BREADCRUMB: 'layout-breadcrumb',
  BREADCRUMB_HOME_BTN: 'layout-breadcrumb-home-btn',
  BREADCRUMB_LINK: (label: string) =>
    `layout-breadcrumb-link-${label.toLowerCase().replace(/\s+/g, '-')}`,

  // ── Footer ──────────────────────────────────────────────────────────────
  FOOTER: 'layout-footer',
} as const;
